export default "__VITE_ASSET__4a77aec7__$_?inline__"